import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/PivotBoard/components/GroupByTable/components/GroupByColumnHeader/GroupByColumnHeader.module.scss';

interface Props {
    primaryGroupLabel: string;
    secondaryGroupLabel?: string;
}

export const GroupByColumnHeader = ({ primaryGroupLabel, secondaryGroupLabel }: Props) => {
    return (
        <div className={classes.centeredFlexRowWithGap}>
            {primaryGroupLabel}
            {secondaryGroupLabel ? (
                <span className={classes.centeredFlexRowWithGap}>
                    <MuiIcon icon={'arrow_forward'} color={'inherit'} /> <span>{secondaryGroupLabel}</span>
                </span>
            ) : null}
        </div>
    );
};
